import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ValueSection from './components/ValueSection';
import ArticleListSection from './components/ArticleListSection';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-background-50">
      <SEOHead
        title="OOPBuy Spreadsheet – Ultimate Product Sourcing & Shopping Guide 2026"
        description="Discover the most efficient way to find, compare, and order products using the OOPBuy Spreadsheet system. Updated product guides, trusted shopping lists, and smart sourcing strategies. Browse Shoes, Hoodies, T-Shirts, Jackets, Bags and more."
        keywords="OOPBuy Spreadsheet, OOPBuy spreadsheet guide, OOPBuy product list, OOPBuy shopping, product sourcing spreadsheet, OOPBuy 2026"
        canonicalUrl="https://oopbuy.surf/"
        ogType="website"
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <ValueSection />
      <ArticleListSection />
      <AboutSection />
      <TestimonialSection />
      <CTASection />
      <FAQSection />
      <Footer />
    </main>
  );
}